import { intersectionWith } from 'lodash'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import ParameterDto from '../../../../referencial/components/parameter/dto/ParameterDto'
import { normalizeString } from '../../../../utils/StringUtil'
import SimpleSelectionTable, { ActiveParameterFilterField } from 'components/datatable/SimpleSelectionTable'
import { getParametersNature, getParametersType } from 'referencial/util/ReferencialUtils'
import { getStatusInformation } from 'referencial/util/StatusUtils'
import useListIndexed from 'utils/customHook/useListIndexed'
import { getDefaultCampaignParameterUnit } from 'campaign/utils/CampaignUtils'

const parameterFilterFunction = (list, { selection = '-1', listParam, searchValue, shouldDisplayNonActive = false }) => {
    const filterActive = shouldDisplayNonActive ? list : list.filter(p => p.active)
    const filterSelection = selection !== '-1' ? intersectionWith(filterActive, listParam, (elem, id) => elem.id === id) : filterActive
    const searchValueFormat = normalizeString(searchValue)
    return searchValue ? filterSelection.filter(p => p.labelSearch.includes(searchValueFormat)) : filterSelection
}

const SelectParameter = ({
    selectedParameters = [],
    onChange = () => {},
}) => {
    const {
        parameters,
    } = useSelector(store => ({
        parameters: store.ParameterReducer.parameters,
    }), shallowEqual)

    const indexedParameters = useListIndexed(parameters, 'code')

    const formattedParameters = useMemo(() => {
        const types = getParametersType()
        const natures = getParametersNature()
        return parameters.map(param => ({
            id: param.code,
            name: `[${param.code}] ${param.name.length > 40 && param.shortLabel || param.name || ''}`,
            type: types[param.nature], // nature and type are inverted in database
            nature: natures[param.typeParam], // nature and type are inverted in database
            status: param.status ? getStatusInformation(param.status) : i18n.validated,
            active: param.active === '1',
            labelSearch: normalizeString([param.name, param.mnemonique, param.code].join(',')),
        }))
    }, [parameters])

    const onChangeSelected = (list = []) => {
        const newSelected = list.map(code => {
            const prev = selectedParameters.find(sp => code === sp.parameterCode)
            return prev ?? {
                parameterCode: code,
                unitCode: getDefaultCampaignParameterUnit(indexedParameters[code]),
                fractionCode: '0',
                placeCode: '0',
                supportCode: '0',
            }
        })
        onChange({ selectedParameters: newSelected })
    }

    return (
        <SimpleSelectionTable
            onChange={onChangeSelected}

            listData={formattedParameters}
            selectedList={selectedParameters.map(sp => sp.parameterCode).filter(p => !!indexedParameters[p])}

            listHeaders={['name', 'type', 'nature', 'status']}
            listTitle={i18n.nonSelectedParameters}
            selectedListTitle={i18n.selectedParameters}
            maxHeightTable='43vh'

            filterField={ActiveParameterFilterField}
            filterFunction={parameterFilterFunction}
        />
    )
}

SelectParameter.propTypes = {
    parameters: PropTypes.arrayOf(PropTypes.instanceOf(ParameterDto)),
    selectedParameters: PropTypes.arrayOf(PropTypes.shape({
        parameterCode: PropTypes.string,
    })),
    onChange: PropTypes.func,
}

export default SelectParameter